var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ApexPieChart',{attrs:{"categories":_vm.categories,"series":_vm.series,"center-value":_vm.centerValue},on:{"category-selected":_vm.onSelect}})
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }